let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9LX6j")).then(() => parcelRequire('exJ4o'));